/*
  Raeuberkinder: Reparatur von Add-to-Cart-Button und Vorbestell-Nachricht, Stand 2026-08-16 (v5).

  Befund (im Browser verifiziert):
  Timesact reagiert beim Variantenwechsel nur teilweise. Es aktualisiert den Buttontext und
  entfernt seine Benachrichtigungs-Schaltflaechen, baut die Vorbestell-Nachricht
  (.timesact-preorder-description) aber nicht neu auf. Beim Wechsel zurueck auf eine
  Lagervariante laesst es ausserdem den Vorbestell-Text auf dem Button stehen. Ein frischer
  Seitenaufbau rendert dagegen fuer jede Variante korrekt.

  Was dieses Skript tut, ohne eigene Texte zu erfinden:

  1. Buttontext: setzt den Theme-Text (data-button-content) zurueck, aber NUR wenn die
     gewaehlte Variante nachweislich echten Lagerbestand hat. Bestandsdaten kommen aus
     #rk-variant-stock, das layout/theme.liquid aus Shopify rendert.
  2. Vorbestell-Nachricht: merkt sich die von Timesact erzeugte Nachricht als Vorlage und
     setzt sie bei Nachproduktions-Varianten an derselben Stelle wieder ein.
  3. Erstbefuellung: startet die Seite auf einer Lagervariante, hat Timesact nie eine
     Nachricht gerendert und es gaebe nichts zu merken. In dem Fall wird Timesacts eigener
     Einstiegspunkt window.timesactScriptNew EINMAL pro Seitenaufruf erneut aufgerufen.
     Timesact rendert dann selbst die passende Nachricht, die anschliessend als Vorlage
     dient. Vor dem Aufruf werden die Elemente entfernt, die Timesact sonst doppelt anlegt.
  4. Schrift: entfernt die schriftbezogenen Inline-Styles von Timesact, damit der Button in
     beiden Zustaenden gleich aussieht. Farben, Hoehe und Rahmen bleiben unangetastet.

  Grundregel: im Zweifel wird nichts behauptet. Ist der Bestand unbekannt, wird weder ein
  Buttontext gesetzt noch eine Lieferzeit eingeblendet.

  Diese Datei kann ersatzlos geloescht werden, sobald Timesact beim Variantenwechsel selbst
  vollstaendig neu rendert. Zugehoerige Script-Zeile und Datenblock: layout/theme.liquid.
*/
(function () {
  var BUTTON_SELECTOR = '[data-product-add-to-cart-button]';
  var TIMESACT_MARKER = 'timesact-button';
  var LABEL_SPANS = '.loader-button__text, .loader-button__loader';
  var MESSAGE_SELECTOR = '.timesact-preorder-description';
  var RESTORED_FLAG = 'data-rk-restored';
  var DUPLICATE_PRONE = 'body > .timesact_bis_popup_overlay, body > .timesact_bis_dialog, .timesact-button-bis, .timesact-button-cs';
  var FONT_PROPS = [
    'font', 'font-family', 'font-size', 'font-style', 'font-weight',
    'font-variant', 'letter-spacing', 'line-height', 'text-transform'
  ];

  var stockMap;
  var currentVariantId = null;
  var messageTemplate = null;
  var messageParent = null;
  var messageAnchor = null;
  var primeDone = false;
  var primeRunning = false;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function getStockMap() {
    if (stockMap !== undefined) return stockMap;
    var node = document.getElementById('rk-variant-stock');
    if (!node) { stockMap = null; return stockMap; }
    try { stockMap = JSON.parse(node.textContent); } catch (e) { stockMap = null; }
    return stockMap;
  }

  function selectedVariantId() {
    if (currentVariantId) return currentVariantId;
    var match = window.location.search.match(/[?&]variant=(\d+)/);
    if (match) return match[1];
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  // true = echter Lagerbestand, false = Nachproduktion, null = unbekannt
  function stockState() {
    var map = getStockMap();
    if (!map) return null;
    var id = selectedVariantId();
    if (!id || !Object.prototype.hasOwnProperty.call(map, id)) return null;
    return map[id] === true;
  }

  function stripFontStyles(element) {
    if (!element || !element.style) return;
    for (var i = 0; i < FONT_PROPS.length; i++) {
      if (element.style.getPropertyValue(FONT_PROPS[i])) {
        element.style.removeProperty(FONT_PROPS[i]);
      }
    }
  }

  function normalizeButton(button, state) {
    stripFontStyles(button);
    each(button.querySelectorAll(LABEL_SPANS), stripFontStyles);

    if (button.disabled) return;                             // Ausverkauft in Ruhe lassen
    if (button.classList.contains(TIMESACT_MARKER)) return;  // Timesact hat sichtbar das Kommando
    if (state !== true) return;                              // Nachproduktion oder unbekannt

    var wanted = button.getAttribute('data-button-content');
    if (!wanted) return;

    var spans = button.querySelectorAll(LABEL_SPANS);
    if (!spans.length) {
      if (button.textContent.trim() !== wanted) button.textContent = wanted;
      return;
    }
    each(spans, function (span) {
      if (span.textContent.trim() !== wanted) span.textContent = wanted;
    });
  }

  function findOriginalMessage() {
    var nodes = document.querySelectorAll(MESSAGE_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].hasAttribute(RESTORED_FLAG)) return nodes[i];
    }
    return null;
  }

  function removeRestoredMessages() {
    each(document.querySelectorAll(MESSAGE_SELECTOR + '[' + RESTORED_FLAG + ']'), function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  // Einmal pro Seitenaufruf: Timesact selbst neu rendern lassen, damit eine Vorlage entsteht.
  function primeTimesact() {
    if (primeDone || primeRunning) return;
    if (typeof window.timesactScriptNew !== 'function' || typeof window.jQuery !== 'function') return;
    primeDone = true;
    primeRunning = true;
    try {
      each(document.querySelectorAll(DUPLICATE_PRONE), function (node) {
        if (node.parentNode) node.parentNode.removeChild(node);
      });
      Promise.resolve(window.timesactScriptNew(window.jQuery)).then(function () {
        primeRunning = false;
        schedule();
      }, function () {
        primeRunning = false;
      });
    } catch (e) {
      primeRunning = false;
    }
  }

  function syncMessage(state) {
    var original = findOriginalMessage();

    // Timesact hat selbst gerendert: Vorlage uebernehmen, eigene Kopie zuruecknehmen.
    if (original) {
      messageTemplate = original.cloneNode(true);
      messageParent = original.parentNode;
      messageAnchor = original.nextSibling;
      removeRestoredMessages();
      return;
    }

    if (state === false) {
      if (!messageTemplate) { primeTimesact(); return; }
      if (messageParent && messageParent.isConnected &&
          !document.querySelector(MESSAGE_SELECTOR + '[' + RESTORED_FLAG + ']')) {
        var clone = messageTemplate.cloneNode(true);
        clone.setAttribute(RESTORED_FLAG, 'true');
        if (messageAnchor && messageAnchor.parentNode === messageParent) {
          messageParent.insertBefore(clone, messageAnchor);
        } else {
          messageParent.appendChild(clone);
        }
      }
      return;
    }

    // Lagerware oder unbekannt: keine Lieferzeitaussage einblenden.
    removeRestoredMessages();
  }

  function tick() {
    if (primeRunning) return;
    var state = stockState();
    each(document.querySelectorAll(BUTTON_SELECTOR), function (button) {
      normalizeButton(button, state);
    });
    syncMessage(state);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      tick();
    });
  }

  function start() {
    tick();
    new MutationObserver(schedule).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'disabled', 'data-button-content']
    });
    document.addEventListener('variant:changed', function (event) {
      var variant = event && event.detail && (event.detail.variant || event.detail);
      if (variant && variant.id) currentVariantId = String(variant.id);
      schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();